import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import SuccessIcon from '@material-ui/icons/Done';
import CopyTextField from '../CopyTextField';
import './NewCreatedAPIKeyDialog.scss';

const NewCreatedAPIKeyDialog = ({
  getKey = k => k.key,
  noDownload = false,
}) => {
  const Dlg = ({ open, onClose, apiKey, newSecretOnly, apiKeyService }) => {
    const handleClose = () => onClose();
    const [blobURL, setBlobURL] = useState(null);
    const [acknowledgeCheck, setChecked] = useState(false);
    const handleAcknowledgeCheck = (event) => {
      setChecked(event.target.checked);
    };

    useEffect(() => {
      async function fetchDownloadURL() {
        setBlobURL(await (apiKeyService.fetchLicenseDownloadURL
            ? apiKeyService.fetchLicenseDownloadURL(apiKey) : Promise.resolve(null)));
      }
      if (!noDownload) {
        if (blobURL) {
          apiKeyService.revokeLicenseDownloadURL(blobURL);
        }
        fetchDownloadURL();
      }
      return () => {
        if (blobURL) {
          apiKeyService.revokeLicenseDownloadURL(blobURL);
        }
      };
    }, [apiKey, apiKeyService]);

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby="new-api-key-dialog-title"
        id="grb-new-created-api-key-dialog-ctnr"
        open={open}
      >
        <DialogContent className="grb-new-created-api-key-dialog">
          <DialogContentText className="grb-new-created-api-key-message">
            <Typography variant="body1" id="new-api-key-dialog-title">
              <SuccessIcon />{newSecretOnly ? 'New secret generated' : 'API Key created'}
            </Typography>
          </DialogContentText>
          <CopyTextField
            autoFocus
            value={getKey(apiKey)}
            id="apiKeyAccessCode"
            label="API Key"
            fullWidth
          />
          <CopyTextField
            autoFocus
            value={apiKey.secret}
            id="apiKeySecret"
            label="Secret"
            fullWidth
          />
          <FormControlLabel
            control={(
              <Checkbox
                checked={acknowledgeCheck}
                onChange={handleAcknowledgeCheck}
                color="secondary"
                size="small"
                inputProps={{ 'aria-label': 'Acknowledge copy secret checkbox' }}
                id="new-created-api-key-dialog-ack"
              />
            )}
            label={`Please keep the new ${newSecretOnly ? 'generated secret' : 'key and the secret'} in a safe place. For security purpose, we will no longer be able to provide you with the secret. However, you can create new API keys at any time. Check this box to acknowledge this`}
          />
        </DialogContent>
        <DialogActions>
          {!!blobURL && (
            <Tooltip title="Download license file">
              <a href={blobURL} download="gurobi.lic" aria-label="download">
                <Button id="new-created-api-key-dialog-download">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" /></svg>
                  Download
                </Button>
              </a>
            </Tooltip>
          )}
          <Button onClick={handleClose} disabled={!acknowledgeCheck} color="primary" id="new-created-api-key-dialog-close">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  Dlg.propTypes = {
    onClose: PropTypes.func.isRequired,
    apiKey: PropTypes.shape({
      key: PropTypes.string,
      secret: PropTypes.string,
    }).isRequired,
    newSecretOnly: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    apiKeyService: PropTypes.shape({
      fetchLicenseDownloadURL: PropTypes.func,
      revokeLicenseDownloadURL: PropTypes.func,
    }).isRequired,
  };

  Dlg.defaultProps = {
    newSecretOnly: false,
  };
  return Dlg;
};

export default NewCreatedAPIKeyDialog;
